import { createAction } from '@mendeley-internal/lib-js-redux-actions';

const submitHandler = submit => (e) => {
  e.preventDefault();
  submit(e.target.querySelector('input[type="text"]').value);
};

export const attachSearchBar = createAction('ATTACH_SEARCH_BAR', (submit) => {
  const searchForm = document.querySelector('#masthead-wrapper form[action*="research-papers"]');
  searchForm.addEventListener('submit', submitHandler(submit));
});

export const showSearchBar = createAction('SHOW_SEARCH_BAR', () => {
  if (process.browser) document.getElementById('masthead-wrapper').classList.add('show-search-bar');
});

export const hideSearchBar = createAction('HIDE_SEARCH_BAR', () => {
  if (process.browser) document.getElementById('masthead-wrapper').classList.remove('show-search-bar');
});

const getRouteTo = () => encodeURIComponent(window.location.href);
export const updateCurrentUrl = createAction('UPDATE_CURRENT_URL', () => {
  if (!process.browser) return;

  document.querySelectorAll('#masthead-wrapper a[href*="routeTo"]').forEach((link) => {
    // eslint-disable-next-line no-param-reassign
    link.href = link.href.replace(/routeTo=[^&]*/, () => `routeTo=${getRouteTo()}`);
  });
});



// WEBPACK FOOTER //
// ./src/universal/ui/actions/masterbrand.js